import { jsx as _jsx } from "react/jsx-runtime";
import '../../shared/css/Space.css';
import '../../shared/css/generic-styles.css';
var Space = function () {
    return null;
};
var styledSpace = function (variant) {
    var StyledComponent = function (_a) {
        var showOn = _a.showOn;
        var showOnSplit = showOn === null || showOn === void 0 ? void 0 : showOn.split(" ").map(function (word) { return "showOn".concat(word.charAt(0).toUpperCase() + word.slice(1)); });
        var className = "space-".concat(variant, " ").concat(showOn ? showOnSplit : '');
        return _jsx("div", { className: className.trim() });
    };
    StyledComponent.displayName = "Space.".concat(variant
        .split('-')
        .map(function (word) { return word[0].toUpperCase() + word.slice(1); })
        .join('')); // Converts kebab-case to PascalCase: "new-section" -> "Space.NewSection"
    return StyledComponent;
};
Space.NewSection = styledSpace('new-section');
Space.Grow = styledSpace('grow');
Space.Content = styledSpace('content');
export { Space };
